import slick from 'slick-carousel'; // eslint-disable-line

let el = '.js-slick';

let config = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: false,
  swipeToSlide: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: false,
  lazyLoad: 'ondemand',
};

function init() {
  // check for el
  if (!document.body.contains(document.querySelector(el))) {
    return;
  }

  // run slick
  $(el).slick(config);

  // lessen the ugly fade effect
  /*
  $(el).on('beforeChange', function(event, slick, currentSlide) {
    $('.js-slick [data-slick-index="' + currentSlide + '"]').fadeTo(200, 0);
  });
  */
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/slick.js